export const downloadCSV = (
  data: any,
  filename: string,
  selectedKeys: string[]
) => {
  const escapeCSV = (value: any): string => {
    if (value === null || value === undefined) return "";
    const stringValue = String(value);
    const escaped = stringValue.replace(/"/g, '""');
    return /[",\n]/.test(escaped) ? `"${escaped}"` : escaped;
  };

  const formatValue = (key: string, value: any): any => {
    if (key === "banned") {
      return value !== "-";
    }

    return value;
  };

  const csvRows = [
    selectedKeys.join(","),
    ...data.map((row: any) =>
      selectedKeys.map((key) => escapeCSV(formatValue(key, row[key]))).join(",")
    ),
  ];

  const csvContent = csvRows.join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
